<script lang="ts">
    import { useTinyRouter } from 'svelte-tiny-router';

    let {
        to,
        class: className = '',
        children,
        ...rest
    }: {
        to: string;
        class?: string;
        children: any;
        [key: string]: any;
    } = $props();

    const router = useTinyRouter();

    function handleClick(e: MouseEvent) {
        // Allow modifier keys to open in new tab / new window
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        router.navigate(to);
    }
</script>

<a href={to} class={className} onclick={handleClick} {...rest}>
    {@render children()}
</a>